module.exports = __webpack_public_path__ + "static/media/admin.e36f318a.svg";